<div class="autocomplete-field">
  <!-- Label row with required indicator -->
  @if (label()) {
    <div class="autocomplete-field__label-row">
      <label class="autocomplete-field__label">{{ label() | translateLang }}@if (required()) {<span class="autocomplete-field__required-asterisk">*</span>}</label>
      @if (helperText()) {
        <span class="autocomplete-field__helper-text">{{ helperText() | translateLang }}</span>
      }
    </div>
  }

  <!-- PrimeNG AutoComplete -->
  <div [class.autocomplete-field__input-wrapper]="showSearchIcon() || showCaretIcon()" [class.autocomplete-field__input-wrapper--with-search]="showSearchIcon()">
    @if (showSearchIcon()) {
      <app-icon name="search" [size]="16" class="autocomplete-field__search-icon" color="var(--colors-text-placeholder)"></app-icon>
    }
    @if (showCaretIcon() && (!value() || !showClear())) {
      <div class="autocomplete-field__caret-trigger" [class.autocomplete-field__caret-trigger--open]="isDropdownOpen()" (click)="onCaretClick()">
        <app-icon name="chevron-down" [size]="10" color="#9F9696"></app-icon>
      </div>
    }
  <p-autoComplete
    [inputStyleClass]="isInvalid() ? 'p-invalid' : ''"
    [(ngModel)]="value"
    [suggestions]="suggestions()"
    [optionLabel]="optionLabel()"
    [placeholder]="placeholder() | translateLang"
    [completeOnFocus]="completeOnFocus()"
    [forceSelection]="forceSelection()"
    [fluid]="true"
    [showClear]="showClear()"
    [disabled]="disabled()"
    (completeMethod)="onSearch($event)"
    (onSelect)="onSelect($event)"
    (onBlur)="onBlur()"
    (onClear)="onClear()"
    (onShow)="onDropdownShow()"
    (onHide)="onDropdownHide()"
    [attr.aria-label]="ariaLabel()"
  >
    <ng-template pTemplate="clearicon">
      <app-icon name="close" [size]="6" color="white"></app-icon>
    </ng-template>
    @if (itemTemplate) {
      <ng-template pTemplate="item" let-item>
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
      </ng-template>
    }
  </p-autoComplete>
  </div>

  <!-- Error message -->
  @if (isInvalid()) {
    <div class="autocomplete-field__error-message">
      {{ errorMessage() | translateLang }}
    </div>
  }
</div>
